<p>{{'EP_TOOL_DESC' | translate}}</p>
<br />
<button class="button button--primary" (click)="goToEpt()">{{ 'EP_TOOL_BUTTON_LABEL' | translate }}</button>
